import React, { useState, useEffect } from 'react';
import { logoService } from '../../services/logoService';

interface DynamicLogoProps {
  className?: string;
  alt?: string;
  fallback?: React.ReactNode;
}

export function DynamicLogo({ className = "", alt = "Arcgel", fallback }: DynamicLogoProps) {
  const [logoUrl, setLogoUrl] = useState<string>(logoService.getCurrentLogoUrl());
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    // Listener para mudanças na logo
    const handleLogoChange = (event: CustomEvent) => {
      setLogoUrl(event.detail.current);
      setHasError(false); // Reset error state when logo changes
    };

    window.addEventListener('logoChanged', handleLogoChange as EventListener);

    return () => {
      window.removeEventListener('logoChanged', handleLogoChange as EventListener);
    };
  }, []);

  const handleError = () => {
    setHasError(true);
  };

  if (hasError && fallback) {
    return <>{fallback}</>;
  }

  return (
    <img 
      src={logoUrl} 
      alt={alt} 
      className={className}
      onError={handleError}
    />
  );
}